/* HUENIT LAB 2.0 — Admin: 로그인 화면 (S2 real).
   라우터가 로그인 전엔 어떤 섹션도 렌더하지 않으므로 이 화면이 곧 진입 게이트다(plan §4.1).
   - live: 개발자 Cognito 계정(email+password) → session.login() → cognito SRP.
     에러는 cognito 가 권한 없음·자격 오류·네트워크로 구분된 한국어 메시지로 던진다.
   - fake: env 미설정 시 아무 계정이나 통과(데모/디자인 검토).
   디자인은 admin.css 토큰만 사용(추가 CSS 없이 인라인 + 유틸 클래스). */
import { useState } from 'react';
import { Icon } from '../../icons/Icon.jsx';
import { useSession } from '../../auth/session.jsx';

export function LoginScreen() {
  const { login, mode } = useSession();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  const fake = mode === 'fake';
  const canSubmit = email.trim() && password && !busy;

  const submit = async (e) => {
    e.preventDefault();
    if (busy) return;
    setError(null); setBusy(true);
    try {
      await login(email.trim(), password);
      // 성공 시 App 게이트가 즉시 콘솔로 전환 — 이 컴포넌트는 언마운트된다.
    } catch (err) {
      setError(err && err.message ? err.message : '로그인에 실패했습니다.');
      setBusy(false);   // 실패 시에만 busy 해제(성공은 언마운트)
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: 24, background: 'var(--ink-100)' }}>
      <form onSubmit={submit} className="panel" style={{ width: 'min(400px, 100%)', padding: 32 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 22 }}>
          <div className="adm-side__logo" style={{ width: 44, height: 44, borderRadius: 13 }}>H</div>
          <div>
            <div style={{ fontSize: 17, fontWeight: 800, color: 'var(--ink-900)' }}>HUENIT LAB 관리자</div>
            <div style={{ fontSize: 12.5, color: 'var(--ink-500)', fontWeight: 600 }}>
              {fake ? '오프라인(데모) 모드' : '개발자 계정으로 로그인하세요'}
            </div>
          </div>
        </div>

        {fake && (
          <div style={{ marginBottom: 18, padding: '10px 12px', borderRadius: 10, background: 'var(--brand-50)', border: '1px solid var(--brand-100)', color: 'var(--brand-700)', fontSize: 12.5, fontWeight: 600, lineHeight: 1.5 }}>
            서버 설정이 없어 데모 모드로 동작합니다. 아무 이메일/비밀번호로 로그인할 수 있습니다.
          </div>
        )}

        <div className="field">
          <label className="field__label">이메일</label>
          <input className="input" type="email" autoComplete="username" value={email}
                 onChange={e => setEmail(e.target.value)} disabled={busy}
                 placeholder="developer@huenit.com" autoFocus />
        </div>
        <div className="field">
          <label className="field__label">비밀번호</label>
          <input className="input" type="password" autoComplete="current-password" value={password}
                 onChange={e => setPassword(e.target.value)} disabled={busy}
                 placeholder="비밀번호" />
        </div>

        {error && (
          <div role="alert" style={{ marginBottom: 14, padding: '10px 12px', borderRadius: 10, background: 'var(--warn-bg)', border: '1px solid #fecdd3', color: 'var(--warn)', fontSize: 12.5, fontWeight: 600, lineHeight: 1.5 }}>
            {error}
          </div>
        )}

        <button type="submit" className="btn btn--primary" disabled={!canSubmit} style={{ width: '100%', opacity: canSubmit ? 1 : 0.6 }}>
          <Icon name={busy ? 'refresh' : 'login'} size={16} />{busy ? '로그인 중…' : '로그인'}
        </button>

        {!fake && (
          <div className="field__hint" style={{ marginTop: 16, textAlign: 'center', lineHeight: 1.6 }}>
            developer 권한 계정만 접근할 수 있습니다.<br />
            자격증명은 저장되지 않으며 이 탭에서만 유지됩니다.
          </div>
        )}
      </form>
    </div>
  );
}

export default LoginScreen;
